import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import AuthStore from './auth.store';

export const store = new Vuex.Store({
    state: {
        apiServer: process.env.VUE_APP_API_SERVER,
    },

    modules: {
        auth: AuthStore,
    },

    mutations: {
    },

    getters: {
        isAdmin(state) {
            return state.auth.user && state.auth.user.isAdmin;
        },

        token(state) {
            return state.auth.token;
        },

        user(state) {
            return state.auth.user;
        },

        group(state) {
            return state.auth.group;
        },

        role(state) {
            return state.auth.user && state.auth.user.role;
        },
    },

    actions: {
    },
});
